import {
  Scale,
  Calendar,
  Landmark,
  FileText,
  BookOpen,
  CheckCircle,
  ArrowDownLeft,
  Handshake,
  Pencil,
  Bell,
  Mail,
  Folder,
  AlertTriangle,
  Timer,
  Search,
  DollarSign,
  Truck,
  AlertOctagon,
  XCircle,
  AlertCircle,
  Flag,
  FileSearch,
  Check,
  Users,
  MoreHorizontal,
  LucideIcon,
} from 'lucide-react';
import { EventType } from '../../../models/TimelineEvent';

export function getEventTypeIcon(eventType: EventType): LucideIcon {
  const iconMap: Record<EventType, LucideIcon> = {
    filing: Scale,
    hearing: Calendar,
    trial: Landmark,
    motion: FileText,
    ruling: BookOpen,
    judgment: CheckCircle,
    appeal: ArrowDownLeft,
    contract_signed: Handshake,
    contract_amendment: Pencil,
    notice: Bell,
    correspondence: Mail,
    evidence_submitted: Folder,
    deadline: AlertTriangle,
    statute_of_limitations: Timer,
    discovery_deadline: Search,
    payment: DollarSign,
    delivery: Truck,
    breach: AlertOctagon,
    termination: XCircle,
    incident: AlertCircle,
    complaint: Flag,
    investigation: FileSearch,
    settlement: Check,
    meeting: Users,
    other: MoreHorizontal,
  };

  return iconMap[eventType] || MoreHorizontal;
}

export function getEventTypeColor(eventType: EventType): string {
  const colorMap: Record<EventType, string> = {
    // Procedural events - Blue shades
    filing: '#1976d2',
    hearing: '#7b1fa2',
    trial: '#5e35b1',
    motion: '#3f51b5',
    ruling: '#303f9f',
    judgment: '#1565c0',
    appeal: '#0277bd',

    // Document events - Green shades
    contract_signed: '#2e7d32',
    contract_amendment: '#388e3c',
    notice: '#43a047',
    correspondence: '#4caf50',
    evidence_submitted: '#66bb6a',

    // Deadline events - Orange/Red shades
    deadline: '#f57c00',
    statute_of_limitations: '#ef6c00',
    discovery_deadline: '#e65100',

    // Business events - Teal shades
    payment: '#00897b',
    delivery: '#00acc1',
    breach: '#d32f2f',
    termination: '#c62828',

    // Investigation events - Amber shades
    incident: '#ffa726',
    complaint: '#fb8c00',
    investigation: '#f57c00',
    settlement: '#4caf50',

    // General - Grey shades
    meeting: '#757575',
    other: '#9e9e9e',
  };

  return colorMap[eventType] || '#9e9e9e';
}

export function getEventTypeLabel(eventType: EventType, t: (key: string) => string): string {
  return t(`common.timeline.eventTypes.${eventType}`);
}
